<app-header sub_titulo="Destinatarios del menú"></app-header>

<div fxLayout="row" fxLayoutAlign="space-around center">
  <div class="spinner-overlay" *ngIf="cargandoDatos">
    <div class="spinner-center">
      <mat-spinner
        *ngIf="cargandoDatos"
        diameter="80"
        color="primary"
      ></mat-spinner>
      <label class="input-label" *ngIf="cargandoDatos"
        >&nbsp; Cargando datos...</label
      >
    </div>
  </div>

  <!-- Panel izquierda -->
  <mat-card
    appearance="outlined"
    style="background-color: #f8f8ff; width: 100%; height: auto"
  >
    <div id="menuDestinatarios" style="min-height: 95vh; height: auto">
      <div
        class="card-body-content"
        style="width: 99%; min-height: 99%; max-height: 99%; height: 95%"
      >
        <br />
        <mat-card appearance="outlined" style="height: 99%">
          <!-- <div class="alineacionSuperiorMenu">
            <h5 style="font-size: 16px">{{"« " +descripcion + " »"}}</h5>
            <a class="alinearBotonRegresarMenu" [routerLink]="[]" (click)="irPaginaInicio()">Regresar a Menú</a>
          </div>


          <h5 class="font-weight-600 f-30 alinear-centrado">Destinatarios del menú</h5> -->

          <div
            class="card-body-content"
            style="width: 99%; display: flex; height: auto"
          >
            <div style="background-color: #f8f8ff; width: 100%; height: auto">
              <mat-card
                appearance="outlined"
                style="background-color: #f8f8ff; width: 99%; height: auto"
              >
                <div class="card-body-content">
                  <div
                    class="contenedor_tabla"
                    style="
                      width: 100%;
                      height: auto;
                      padding-top: 30px;
                      padding-bottom: 30px;
                    "
                  >
                    <mat-table
                      #table
                      [dataSource]="dataSource"
                      matSort
                      class="mat-elevation-z8"
                    >
                      <ng-container matColumnDef="select">
                        <mat-header-cell
                          *matHeaderCellDef
                          class="column-width-50"
                        >
                          <mat-checkbox
                            (change)="$event ? masterToggle() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="
                              selection.hasValue() && !isAllSelected()
                            "
                          >
                          </mat-checkbox>
                        </mat-header-cell>
                        <mat-cell
                          *matCellDef="let element"
                          class="column-width-50"
                          [ngStyle]="
                            element.habilitado
                              ? { 'background-color': 'rgb(240 243 243)' }
                              : { 'background-color': 'rgba(0,0,0,.12)' }
                          "
                        >
                          <mat-checkbox
                            (click)="$event.stopPropagation()"
                            (change)="$event ? selection.toggle(element) : null"
                            [checked]="selection.isSelected(element)"
                          >
                          </mat-checkbox>
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="titulo">
                        <mat-header-cell
                          *matHeaderCellDef
                          mat-sort-header
                          class="column-width-25-percent"
                        >
                          Título
                        </mat-header-cell>
                        <mat-cell
                          *matCellDef="let element"
                          class="column-width-25-percent"
                          [ngStyle]="
                            element.habilitado
                              ? { 'background-color': 'rgb(240 243 243)' }
                              : { 'background-color': 'rgba(0,0,0,.12)' }
                          "
                        >
                          {{ element.titulo }}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="descripcion">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                          Descripción
                        </mat-header-cell>
                        <mat-cell
                          *matCellDef="let element"
                          [ngStyle]="
                            element.habilitado
                              ? { 'background-color': 'rgb(240 243 243)' }
                              : { 'background-color': 'rgba(0,0,0,.12)' }
                          "
                        >
                          {{ element.descripcion }}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="targetType">
                        <mat-header-cell
                          *matHeaderCellDef
                          mat-sort-header
                          class="textoCentradoTabla column-width-100"
                        >
                          Tipo
                        </mat-header-cell>
                        <mat-cell
                          *matCellDef="let element"
                          class="textoCentradoTabla column-width-100"
                          [ngStyle]="
                            element.habilitado
                              ? { 'background-color': 'rgb(240 243 243)' }
                              : { 'background-color': 'rgba(0,0,0,.12)' }
                          "
                        >
                          {{
                            element.targetType == "Workgroup"
                              ? "CHAT"
                              : element.targetType
                          }}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="habilitado">
                        <mat-header-cell
                          *matHeaderCellDef
                          mat-sort-header
                          class="textoCentradoTabla column-width-150"
                        >
                          Habilitado
                        </mat-header-cell>
                        <mat-cell
                          *matCellDef="let element"
                          class="textoCentradoTabla column-width-150"
                          [ngStyle]="
                            element.habilitado
                              ? { 'background-color': 'rgb(240 243 243)' }
                              : { 'background-color': 'rgba(0,0,0,.12)' }
                          "
                        >
                          {{ element.habilitado ? "Si" : "No" }}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="target">
                        <mat-header-cell
                          *matHeaderCellDef
                          mat-sort-header
                          class="textoCentradoTabla column-width-250"
                        >
                          Destino
                        </mat-header-cell>
                        <mat-cell
                          *matCellDef="let element"
                          class="textoCentradoTabla column-width-250"
                          [ngStyle]="
                            element.habilitado
                              ? { 'background-color': 'rgb(240 243 243)' }
                              : { 'background-color': 'rgba(0,0,0,.12)' }
                          "
                        >
                          {{ element.target }}
                        </mat-cell>
                      </ng-container>

                      <mat-header-row
                        *matHeaderRowDef="displayedColumns"
                      ></mat-header-row>
                      <mat-row
                        *matRowDef="let row; columns: displayedColumns"
                      ></mat-row>
                    </mat-table>
                    <mat-paginator
                      [length]="100"
                      [pageSize]="25"
                      [pageSizeOptions]="[5, 10, 25, 100]"
                    >
                    </mat-paginator>
                  </div>
                </div>
                <div
                  style="
                    width: 100%;
                    height: auto;
                    padding-top: 30px;
                    padding-bottom: 30px;
                  "
                >
                  <span class="padding-right-10">
                    <button
                      mat-raised-button
                      color="primary"
                      (click)="applyOperation()"
                      style="
                        padding-bottom: 10px;
                        padding-top: 10px;
                        margin-right: 10px;
                        margin-top: 10px;
                      "
                    >
                      Aplicar cambios
                    </button>
                  </span>

                  <span class="padding-right-10">
                    <button
                      mat-raised-button
                      (click)="cancelOperation()"
                      style="
                        padding-bottom: 10px;
                        padding-top: 10px;
                        margin-right: 10px;
                        margin-top: 10px;
                      "
                    >
                      Cancelar
                    </button>
                  </span>
                </div>
              </mat-card>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </mat-card>
</div>
